module.exports = __webpack_public_path__ + "static/media/tip_text_dog_flea_en.940697d8.svg";